import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, TableContainer, Table, TableBody, TableRow, TableCell, IconButton } from "@material-ui/core";
import ListIcon from '@material-ui/icons/List';
import TableHeader from '../../Common/TableHeader';
import t from "../../../languages/pl";
import { notArrayOrEmpty } from '../../../utils/helpers';
import NoData from '../../Common/NoDataRow';
import guid from './../../../utils/guid';

const useStyles = theme => ({
    table: {
        paddingTop: theme.spacing(1),
        maxHeight: "68vh"
    },
    cell: {
        textAlign: "center",
        padding: theme.spacing(1)
    }
});

const tableHeader = [t.name, t.perHour, t.from1To3Days, t.from4to7Days, t.above7Days, t.ratePerKilometerAboveLimit, t.manage ];

const PricingTable = props => {
    const { classes, priceList, onDetailsClick } = props;

    const printTable = data => {
        if(notArrayOrEmpty(data))
            return <NoData colSpan={7} />;
        return data.map(row => (
            <TableRow key={guid()}>
                <TableCell className={classes.cell}>
                    {row.nazwa}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.stawka_godzinna}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.stawka_1_3dni}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.stawka_4_7dni}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.stawka_tygodniowa}
                </TableCell>
                <TableCell className={classes.cell}>
                    {row.stawka_pow_limit}
                </TableCell>
                <TableCell className={classes.cell}>
                    <IconButton size="small" onClick={() => onDetailsClick(row.cennik_id)}>
                        <ListIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
        ));
    };

    return (
        <TableContainer className={classes.table}>
            <Table stickyHeader>
                <TableHeader data={tableHeader} />
                <TableBody>
                    {printTable(priceList)}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

PricingTable.propTypes = {
    classes: PropTypes.object,
    priceList: PropTypes.array,
    onDetailsClick: PropTypes.func
};

export default withStyles(useStyles)(PricingTable);
